module.exports = __webpack_public_path__ + "static/media/book.8c5cefe8.svg";